import logoVariants from '@/assets/img/logo';
import { HStack, Image } from '@chakra-ui/react';
import React from 'react';
import LogoSpinner from '../LogoSpinner';

interface Props {
  width?: string;
  height?: string;
  spinnerSize?: string;
  spacing?: string;
  showsText?: boolean;
  variant?: 'dark' | 'light';
}

const LoadingLogo = ({
  width = '148px',
  height,
  spinnerSize,
  spacing = '24px',
  showsText = true,
  variant = 'dark',
}: Props) => {
  return (
    <HStack spacing={spacing} alignItems={'center'}>
      <LogoSpinner size={spinnerSize} variant={variant} />
      {showsText && (
        <Image
          src={variant === 'dark' ? logoVariants.mediumBlueText145x31 : logoVariants.whiteText145x31}
          width={width}
          height={height}
          objectFit={'cover'}
        />
      )}
    </HStack>
  );
};

export default LoadingLogo;
